
import DashboardLayout from "@/components/DashboardLayout";
import SharedPageHeader from "@/components/SharedPageHeader";
import DashboardStats from "@/components/dashboard/DashboardStats";
import RecentOrders from "@/components/dashboard/RecentOrders";
import QuickActions from "@/components/dashboard/QuickActions";
import { useEtsyStore } from "@/hooks/useEtsyStore";
import { useDashboardStats } from "@/hooks/useDashboardStats";
import { formatRevenue } from "@/utils/currencyFormatter";

const Dashboard = () => {
  const {
    isConnected,
    checkConnection,
  } = useEtsyStore();

  const { stats, isLoading } = useDashboardStats();

  const handleConnectionChange = async (connected: boolean) => {
    if (!connected) {
      // Connection will be updated automatically by the store
      await checkConnection(true); // Force refresh
    }
  };

  return (
    <DashboardLayout>
      <SharedPageHeader
        title="Dashboard"
        description="Welcome back! Here's what's happening with your store."
        feature="dashboard analytics and data"
        isConnected={isConnected}
        onConnectionChange={handleConnectionChange}
      >
        {/* Stats Grid */}
        <DashboardStats 
          stats={stats}
          isLoading={isLoading}
          isConnected={isConnected}
          formatRevenue={formatRevenue}
        />

        {/* Recent Activity */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <RecentOrders 
            recentOrders={stats.recentOrders}
            isConnected={isConnected}
            isLoading={isLoading}
            formatRevenue={formatRevenue}
          />
          
          <QuickActions />
        </div>
      </SharedPageHeader>
    </DashboardLayout>
  );
};

export default Dashboard;
